import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import EditVat from "./Editvat.jsx";
import {
  ActiveCell,
  SignatureCell,
  EditCommandCell,
  VatReturnCell,
  VatDetailsCell,
} from "../GridComponents.jsx";
import { useVatsWithDefault, updateVat } from "../../../services/vatService.js";
import { GridLoader } from "components/GridLoader.jsx";

const Vatlist = () => {
  const [openForm, setOpenForm] = React.useState(false);
  const [editItem, setEditItem] = React.useState(null);

  const { data: vats = [], loading: isLoading } = useVatsWithDefault();

  const transformedData = vats?.map((item) => ({
    ...item,
    symbol: item.details?.[0] || "",
  }));

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    const data = {
      vatCodeId: event.vatCodeId,
      details: event.details,
      rate: event.rate,
      includeInVatReturn: event.includeInVatReturn,
      active: event.active,
    };
    const result = await updateVat(event.vatCodeId, data);
    if (result.success) {
      setOpenForm(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid h-100">
      <Grid data={transformedData} loading={isLoading} total={vats.length} style={{ height: "100%" }}
        showLoader={isLoading} loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }
      >
        <GridNoRecords>
          {isLoading ? (
            <span></span>
          ) : (
            transformedData && transformedData?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column cell={SignatureCell} title=" " field="symbol" width="80" />
        <Column
          field="vatCodeId"
          title="VAT Code"
          className="ps-4"
          width="120"
        />
        <Column cell={VatDetailsCell} title="Details" className="text-right" />
        <Column
          field="rate"
          title="Rate"
          className="text-right ps-3"
          width="80"
        />
        <Column cell={VatReturnCell} title="VAT Return" width="120" />
        <Column cell={ActiveCell} title="Active" width="80" />
        <Column title="Edit" cell={MyEditCommandCell} width="80" />
      </Grid>

      {openForm && (
        <EditVat
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default Vatlist;
